import React from 'react'

class LogoPromo extends React.Component {
    render() {
        return (

            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500">
                <g fill="none" fill-rule="evenodd">
                    <path fill="#EF66A1" d="M182.464 140.427c-2.072-48.212-9.5-118.348-17.72-120.236-13.636-3.13-17.464 87.146-18.52 130.866-1.872.64-3.744 1.276-5.66 1.952-8.16 2.888-19.348 8.02-29.616 16.876-11.752-9.176-35.844-25.184-54.412-19.068 0 0 12.324 35.34 35.564 43.68-.592 1.252-1.16 2.532-1.7 3.848-12.52-9.276-34.3-22.404-51.4-16.772 0 0 13.412 38.625 38.696 44.7 2.34.565 4.468 1.005 6.5 1.393-.32 6.864-.016 14.316 1.076 22.42 0 0 17.972 123.996 40.456 173.668 0 0 79.896 30.41 121.164 38.52 0 0 50.512-72.495 58.092-120.01l-54.112-91.08s59.948-23.68 67.716-43.217c7.168-18.032-3.748-99.44-136.124-67.536"/>
                    <path fill="#FEFEFE" d="M200.14 210.06l4.356-29.18-5.14-.768L195 209.296"/>
                    <path fill="#FEFEFE" d="M214.18 200.604L185 196.248l.768-5.136 29.18 4.352"/>
                </g>
            </svg>

        );
    }
}

export default LogoPromo



// WEBPACK FOOTER //
// ../components/SVG/LogoPromo.jsx